export enum ECartPageState {
  LOADING,
  DEFAULT,
  GIFT_PACKAGING,
  ORDER_AS_LAST_TIME,
  ORDER_LIMIT_NOTIFICATION,
  BENEFIT_FREE_DELIVERY,
  FREE_DELIVERY_PRODUCTS,
  INSURANCE_SERVICE_INFO_MODAL,
  GIFT_PACKAGING_SERVICE_INFO_MODAL,
}
